import {
    availableFontStyle,
    availableFontSizes,
    availableTextAlign,
    availableBorderWidth,
    availableBorderStyle,
    availableBorderRadius
} from '../../constants/availableFonts';

const initialState = {
    availableFontStyles: availableFontStyle,
    availableFontSizes: availableFontSizes,
    availableButtonStyles: [
        { label: 'Solid', key: 'solid' },
        { label: 'Flat', key: 'spark-btn--secondary' }
    ],
    availableButtonShapes: [
        { label: 'Rounded Corners', key: 'rounded' },
        { label: 'Square Corners', key: 'square' }
    ],
    availableBorderWidth: availableBorderWidth,
    availableBorderStyle: availableBorderStyle,
    availableBorderRadius: availableBorderRadius,
    availableTextAlign: availableTextAlign
};

const buttonsReducer = (state = initialState, action) => {
    return state;
};

export default buttonsReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/buttons.js